import React, { useState, useRef, useEffect } from 'react';
import { useStyles } from './utils/styles';
import FAQSection from './FAQSection';
import OnboardingSection from './OnboardingSection';
import FooterSection from './FooterSection';
import HeroSection from './HeroSection';

// ─── Main Component ───────────────────────────────────────────────────────────
export function OnboardingPage() {
  const classes = useStyles();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [activeStep, setActiveStep] = useState<number | null>(null);
  const [faqExpanded, setFaqExpanded] = useState<string | false>(false);

  const onboardingRef = useRef<HTMLDivElement>(null);
  const faqRef = useRef<HTMLDivElement>(null);
  const stepRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (activeStep !== null) {
      setTimeout(() => {
        stepRefs.current[activeStep - 1]?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 320);
    }
  }, [activeStep]);


  const scrollToOnboarding = () => {
    setShowOnboarding(true);
    setTimeout(() => {
      onboardingRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  return (
    <div className={classes.root}>
      <HeroSection
        onScrollToOnboarding={scrollToOnboarding}
      />


      <OnboardingSection
        classes={classes}
        onboardingRef={onboardingRef}
        showOnboarding={showOnboarding}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        stepRefs={stepRefs}
      />

      <FAQSection
        ref={faqRef}
        classes={classes}
        expanded={faqExpanded}
        onChange={(panel: string | false) => setFaqExpanded(panel)}
      />

      <FooterSection />
    </div>
  );
}

export default OnboardingPage;
